import { computed } from "vue";
import { useStoreItem } from "../itemStore.store";
import { momentumStructure, useMomentumStore } from "./momentums.store";
import { useTargetStore } from "../target/targets.store";
import { useResourceStore } from "../resource/resources.store";

export const useMomentum = useStoreItem(
  momentumStructure,
  useMomentumStore,
  (momentum, _store) => {
    const items = computed(() => {
      return {
        target: useTargetStore().items,
        resource: useResourceStore().items
      };
    });
    
    const element = computed(() => {
      if (momentum.value?.elementType == null || momentum.value?.elementId == null) return null;
      return items.value[momentum.value.elementType]?.[momentum.value.elementId];
    });

    return {
      element
    };
  }
);
